export default "__VITE_ASSET__ec8dfc63__"